// Illustrated cup used where no product photo exists.
export const FlavorCup = ({ color = "#c69c6d", className = "", label }) => (
  <svg viewBox="0 0 200 320" className={className} role="img" aria-label={label ? `Illustration of ${label}` : "Drink illustration"}>
    <defs>
      <linearGradient id={`liq-${color.slice(1)}`} x1="0" x2="0" y1="0" y2="1">
        <stop offset="0" stopColor="#fff" stopOpacity="0.55" />
        <stop offset="0.25" stopColor={color} />
        <stop offset="1" stopColor={color} stopOpacity="0.92" />
      </linearGradient>
    </defs>
    <rect x="112" y="6" width="14" height="90" rx="7" fill="#1a0a10" transform="rotate(12 119 50)" />
    <path d="M30 70 Q100 40 170 70 L166 86 L34 86 Z" fill="#ffffff" fillOpacity="0.9" />
    <path d="M38 88 L162 88 L148 300 Q100 312 52 300 Z" fill="#ffffff" fillOpacity="0.55" />
    <path d="M44 112 L156 112 L146 296 Q100 306 54 296 Z" fill={`url(#liq-${color.slice(1)})`} />
    {[[70, 270], [92, 280], [116, 276], [136, 266], [80, 252], [104, 258], [126, 248]].map(([x, y], i) => (
      <circle key={i} cx={x} cy={y} r="9" fill="#2a1309" />
    ))}
    <circle cx="100" cy="190" r="26" fill="none" stroke="#1a0a10" strokeOpacity="0.55" strokeWidth="4" />
    <path d="M86 196 L114 196 L110 210 L90 210 Z" fill="#1a0a10" fillOpacity="0.55" />
    <path d="M60 120 L66 290" stroke="#fff" strokeOpacity="0.5" strokeWidth="6" strokeLinecap="round" />
  </svg>
);
